import { useTranslations } from 'next-intl';
import { ButtonV2 } from 'components/shared/ButtonV2';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import HeroCards from './HeroCards';
import styles from './HeroSection.module.css';

const HERO_IMAGE_DESKTOP = 'web_v2/photon/landing-page/hero-desktop.png';
const HERO_IMAGE_MOBILE = 'web_v2/photon/landing-page/hero.png';

export const HeroSection = () => {
  const t = useTranslations('photon');

  return (
    <section
      className={styles.section}
      role="banner"
      aria-label={t('photon.heroSection.ariaLabel.photonHero')}
    >
      <div className={styles.textBlock}>
        <p className={styles.eyebrow}>
          {t('photon.heroSection.eyebrow.newLaunch')}
        </p>
        <h1 className={styles.headline}>
          {t('photon.heroSection.title.ultrahumanPhoton')}
        </h1>
        <p className={styles.description}>
          {t('photon.heroSection.description.dailyPlan')}
        </p>
        <div className={styles.ctaWrapper}>
          {/* Photon is out of stock: the CTA stays as a plain disabled
              button (no href) so neither click nor keyboard nav navigates. */}
          <ButtonV2
            className={styles.outOfStockCta}
            aria-label={t('photon.heroSection.button.outOfStock')}
            disabled
          >
            {t('photon.heroSection.button.outOfStock')}
          </ButtonV2>
        </div>
      </div>

      <div className={styles.productWrapper}>
        <div className={styles.productInner}>
          <CustomImage
            className={styles.desktopImage}
            src={HERO_IMAGE_DESKTOP}
            alt={t('photon.heroSection.image.photonDevice')}
            width={4395}
            height={4266}
            priority
          />
          <CustomImage
            className={styles.mobileImage}
            src={HERO_IMAGE_MOBILE}
            alt={t('photon.heroSection.image.photonDevice')}
            width={4395}
            height={4266}
            priority
          />
          <HeroCards />
        </div>
      </div>
    </section>
  );
};
